import React from 'react';
import { Mail, MapPin, LucideSmartphone } from 'lucide-react';

export default function Contact() {
    return (
        <main className="max-w-4xl mx-auto p-6">
            <h1 className="text-4xl font-bold mb-6 text-center text-gray-800">Contáctanos</h1>
            <div className="bg-white shadow-xl rounded-2xl p-8 space-y-6">
                <div className="flex items-start space-x-4">
                    <MapPin className="text-indigo-600" />
                    <div>
                        <h2 className="font-semibold text-lg">Dirección Fiscal Inspira</h2>
                        <p>Insurgentes Centro 56 Interior 401 y 402,<br />Col. Tabacalera, Cuauhtémoc,<br />C.P. 06030, Ciudad de México</p>
                    </div>
                </div>
                <div className="flex items-start space-x-4">
                    <Mail className="text-indigo-600" />
                    <div>
                        <h2 className="font-semibold text-lg">Correo Electrónico</h2>
                        <a href="mailto:info@inspiracambio.org" className="text-indigo-600 hover:underline">info@inspiracambio.org</a>
                    </div>
                </div>
                <div className="flex items-start space-x-4">
                    <LucideSmartphone className="text-green-600" />
                    <div>
                        <h2 className="font-semibold text-lg">WhatsApp</h2>
                        <a href="https://wa.me/525540328901" className="text-green-600 hover:underline">+52 55 4032 8901</a>
                    </div>
                </div>
            </div>
        </main>
    );
}